export const HarvestCycleStyles = {
  '& .Harvest__summary': {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
    gap: '10px',
    marginBottom: '20px',
  },
  '& .Harvest__stat': {
    background: '#fff',
    border: '1px solid #e0e0e0',
    borderLeft: '3px solid var(--bar, #9e9e9e)',
    borderRadius: '3px',
    padding: '12px 14px',
  },
  '& .Harvest__stat-n': {
    fontSize: '26px',
    lineHeight: 1,
    fontVariantNumeric: 'tabular-nums',
    color: 'var(--bar, #333)',
    fontWeight: 600,
  },
  '& .Harvest__stat-k': {
    fontSize: '11.5px',
    textTransform: 'uppercase',
    letterSpacing: '.06em',
    color: '#666',
    marginTop: '6px',
  },
  '& .Harvest__stat-d': {
    fontSize: '12px',
    color: '#8a8a8a',
    marginTop: '2px',
    lineHeight: 1.35,
  },
  '& .Harvest__scroller': {
    overflowX: 'auto',
    background: '#fff',
    border: '1px solid #e0e0e0',
    borderRadius: '3px',
  },
  '& .Harvest__table': {
    borderCollapse: 'collapse',
    width: '100%',
    minWidth: '900px',
    '& thead th': {
      textAlign: 'left',
      padding: 0,
      borderBottom: '1px solid #e0e0e0',
      whiteSpace: 'nowrap',
    },
    '& .Harvest__sort': {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      width: '100%',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      font: 'inherit',
      fontSize: '11px',
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '.07em',
      color: '#777',
      padding: '12px',
      textAlign: 'left',
      '&:hover': { color: '#0e6b78' },
      '&:focus-visible': { outline: '2px solid #0e6b78', outlineOffset: '-2px' },
      '&.active': { color: '#0e6b78' },
    },
    '& .Harvest__caret': { fontSize: '9px', opacity: 0.55, lineHeight: 1 },
    '& .Harvest__sort.active .Harvest__caret': { opacity: 1 },
    '& tbody td': {
      padding: '10px 12px',
      borderBottom: '1px solid #f0f0f0',
      verticalAlign: 'middle',
    },
    '& tbody tr:last-child td': { borderBottom: 'none' },
  },
  '& .Harvest__src': { fontWeight: 550, lineHeight: 1.3 },
  '& .Harvest__srcauth': {
    fontSize: '12px',
    color: '#8a8a8a',
    marginTop: '2px',
    '& a': { color: '#0e6b78', textDecoration: 'none' },
    '& a:hover': { textDecoration: 'underline' },
  },
  '& .Harvest__srcmeta': {
    fontSize: '12px',
    color: '#8a8a8a',
    marginTop: '2px',
    fontVariantNumeric: 'tabular-nums',
  },
  '& .Harvest__num': { fontVariantNumeric: 'tabular-nums', fontSize: '13.5px' },
  '& .Harvest__chip': {
    display: 'inline-block',
    fontSize: '11px',
    fontWeight: 650,
    letterSpacing: '.05em',
    textTransform: 'uppercase',
    padding: '3px 8px',
    borderRadius: '2px',
    whiteSpace: 'nowrap',
  },
  // Two families read apart at a glance: red for something wrong with the data,
  // teal for a harvest already in our hands and moving.
  '& .status-harvested_blocked': { background: '#f6e4e1', color: '#a93b2d' },
  '& .status-due': { background: '#f7eedc', color: '#8f6414' },
  '& .status-harvested_review': { background: '#e3eff1', color: '#0e6b78' },
  '& .status-current': { background: '#e4f0ea', color: '#2e7d5b' },
  '& .status-not_measured': { background: '#eef0f1', color: '#78868c' },
  // Why a Blocked source is blocked: a quiet tag next to the chip.
  '& .Harvest__reason': {
    display: 'inline-block',
    marginLeft: '6px',
    fontSize: '11px',
    fontWeight: 600,
    color: '#a93b2d',
    whiteSpace: 'nowrap',
  },
  // The catalog verdict beside the MCD year.
  '& .Harvest__verdict': {
    display: 'inline-block',
    marginLeft: '6px',
    fontSize: '10.5px',
    fontWeight: 600,
    padding: '1px 5px',
    borderRadius: '2px',
    cursor: 'help',
    '&.ok': { background: '#e4f0ea', color: '#2e7d5b' },
    '&.stale': { background: '#f6e4e1', color: '#a93b2d' },
  },
  '& .Harvest__statusdetail': {
    fontSize: '12px',
    color: '#8a8a8a',
    marginTop: '4px',
    maxWidth: '26ch',
    lineHeight: 1.35,
  },
  '& .Harvest__est': {
    fontSize: '10.5px',
    color: '#9aa4a8',
    marginLeft: '5px',
    cursor: 'help',
    borderBottom: '1px dotted currentColor',
  },
  '& .Harvest__grid': { display: 'flex', gap: '2px' },
  '& .Harvest__cell': {
    width: '11px',
    height: '20px',
    borderRadius: '1px',
    background: '#f0f2f3',
    '&.has': { background: '#cbd6d9' },
    '&.full': { background: '#0e6b78' },
    '&.part': { background: '#b07d1a' },
  },
  '& .Harvest__warn': { color: '#a93b2d', fontSize: '12px', marginLeft: '6px' },
  '& .Harvest__toggle': {
    cursor: 'pointer',
    fontSize: '12px',
    color: '#0e6b78',
    background: 'none',
    border: 'none',
    borderBottom: '1px dotted currentColor',
    padding: '2px 0',
    marginTop: '5px',
  },
  '& .Harvest__vars': {
    marginTop: '8px',
    borderLeft: '2px solid #e3eeef',
    paddingLeft: '12px',
  },
  '& .Harvest__vrow': {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '12px',
    fontSize: '12.5px',
    padding: '3px 0',
    borderBottom: '1px solid #f4f6f6',
  },
  '& .Harvest__vdomain': {
    fontSize: '10.5px',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '.07em',
    color: '#0e6b78',
    marginTop: '10px',
    marginBottom: '2px',
    '&:first-of-type': { marginTop: '2px' },
  },
  '& .Harvest__vname': { color: '#3d4b52', lineHeight: 1.4 },
  '& .Harvest__vkind': {
    display: 'inline-block',
    fontSize: '10px',
    fontWeight: 650,
    textTransform: 'uppercase',
    letterSpacing: '.05em',
    padding: '1px 5px',
    marginLeft: '7px',
    borderRadius: '2px',
    background: '#eef0f1',
    color: '#78868c',
    cursor: 'help',
    verticalAlign: '1px',
    '&.calc': { background: '#f0eaf4', color: '#6b4f86' },
  },
  '& .Harvest__vneeds': {
    display: 'block',
    fontSize: '11.5px',
    color: '#6b4f86',
    marginTop: '1px',
  },
  // A variable nothing in the app displays: same badge shape as Loaded /
  // Calculated, muted so it reads as a footnote rather than a state.
  '& .Harvest__vkind.hidden': {
    background: '#efefef',
    color: '#777',
    borderColor: '#ddd',
  },
  // Where a variable moved between datasources; one quiet line under the name.
  '& .Harvest__vhandover': {
    display: 'block',
    fontSize: '11.5px',
    color: '#5f6b73',
    marginTop: '1px',
    '& b': { fontWeight: 600 },
  },
  // A dependency on another datasource is the one worth spotting, so it gets
  // its own mark rather than disappearing into the list of variable names.
  '& .Harvest__vexternal': {
    display: 'inline-block',
    marginLeft: '6px',
    padding: '0 5px',
    borderRadius: '2px',
    background: '#f0eaf4',
    fontSize: '11px',
    fontWeight: 600,
  },
  '& .Harvest__vcol': {
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
    fontSize: '11.5px',
    color: '#8a969c',
    marginLeft: '7px',
    wordBreak: 'break-all',
  },
  '& .Harvest__vyr': {
    fontVariantNumeric: 'tabular-nums',
    whiteSpace: 'nowrap',
    color: '#8a8a8a',
    '&.bad': { color: '#a93b2d', fontWeight: 600 },
  },
  '& .Harvest__legend': {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
    marginTop: '12px',
    fontSize: '12px',
    color: '#666',
    '& span': { display: 'flex', alignItems: 'center', gap: '6px' },
  },
  '& .Harvest__sw': { width: '11px', height: '11px', borderRadius: '1px', display: 'inline-block' },
  // The election-type breakdown: four (five, with the pre-2013 references)
  // disclosure rows hanging off the Election Date variable, each opening into
  // the dates loaded under it.
  '& .Harvest__types': {
    marginTop: '8px',
    marginBottom: '4px',
  },
  '& .Harvest__type': { borderBottom: '1px solid #f4f6f6' },
  '& .Harvest__typehead': {
    display: 'flex',
    alignItems: 'baseline',
    gap: '10px',
    width: '100%',
    padding: '5px 0',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    textAlign: 'left',
    font: 'inherit',
    '&:hover .Harvest__typename': { textDecoration: 'underline' },
    '& .Harvest__caret': { marginLeft: 'auto', fontSize: '10px', color: '#0e6b78' },
  },
  '& .Harvest__typename': {
    fontSize: '12.5px',
    fontWeight: 650,
    color: '#0e6b78',
    minWidth: '11ch',
  },
  '& .Harvest__typemeta': {
    fontSize: '12px',
    color: '#8a8a8a',
    fontVariantNumeric: 'tabular-nums',
  },
  '& .Harvest__dates': {
    listStyle: 'none',
    margin: '0 0 8px',
    padding: '2px 0 2px 12px',
    borderLeft: '2px solid #e3eeef',
    columns: '2',
    columnGap: '24px',
    '& li': {
      breakInside: 'avoid',
      display: 'flex',
      alignItems: 'baseline',
      gap: '8px',
      padding: '2px 0',
      fontSize: '12px',
    },
    '& li.unmapped': { opacity: 0.7 },
  },
  '& .Harvest__dateval': {
    fontVariantNumeric: 'tabular-nums',
    whiteSpace: 'nowrap',
    color: '#3d4b52',
    minWidth: '11ch',
  },
  '& .Harvest__datetitle': {
    color: '#8a969c',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  '& .Harvest__vnote': {
    margin: '6px 0 0',
    fontSize: '12px',
    color: '#8a8a8a',
  },
  '& .Harvest__note': {
    marginTop: '20px',
    fontSize: '13px',
    color: '#666',
    maxWidth: '78ch',
    lineHeight: 1.5,
  },
};
